import React, { useLayoutEffect } from 'react';
import '../../assets/styles/adminBrand.scss';
import '../../assets/styles/adminWorkspace.scss';

/** Authenticated routes only. Body scope includes MUI portals and is removed
 * before login/recovery renders; no persistent preference or auth state changes. */
export default function AdminTheme({ children }: { children: React.ReactNode }) {
  useLayoutEffect(() => {
    document.body.classList.add('avatus-admin-theme');
    return () => document.body.classList.remove('avatus-admin-theme');
  }, []);
  return <>{children}</>;
}
